import ToolTip from "components/design/toolTip";
import { Tag } from "components/DesignSystem/Tag/Tag";
import React from "react";
import { CircularFlag } from "./NoOfSubsidiaries";
import { SmallCircleCross } from "components/icons/SmallCircleCross";
import { SmallCircleGreenTick } from "components/icons/SmallCircleGreenTick";
import { NonUsSubsidiaryBooksSlider } from "../TaskSlider/NonUsSubsidiaryBooksSlider";
import { useModal } from "hooks/useModal";
import { NonUsSubsidiary } from "types/Models/TaskTracker";

export const NonUsSubsidiaryBooks = ({
  totalNonUsSubsidiaryBooks,
  receivedNonUsSubsidiaryBooks,
  nonUsSubsidiaryBooks,
  groupName,
  taskName,
}: {
  totalNonUsSubsidiaryBooks: number;
  receivedNonUsSubsidiaryBooks: number;
  nonUsSubsidiaryBooks: NonUsSubsidiary[];
  groupName: string;
  taskName: string;
}) => {
  const nonUsSubsidiaryBookSlider = useModal();
  const isAllReceived =
    totalNonUsSubsidiaryBooks == receivedNonUsSubsidiaryBooks;

  const handleCellClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    nonUsSubsidiaryBookSlider.open();
  };

  if (totalNonUsSubsidiaryBooks == 0) {
    return "-";
  }

  return (
    <div onClick={handleCellClick}>
      <ToolTip
        text={
          <div className="t-flex t-flex-col t-gap-2">
            {nonUsSubsidiaryBooks.map((entity, index) => (
              <div key={entity.uuid} className="t-flex t-items-center t-gap-1">
                <CircularFlag countryCode={entity.country.code} />
                <span className="t-text-body-sm t-text-surface">
                  {entity.name}
                </span>

                {isAllReceived ? (
                  <span className="t-text-dark_green">
                    <SmallCircleGreenTick />
                  </span>
                ) : (
                  <span className="t-text-red-50">
                    <SmallCircleCross />
                  </span>
                )}
              </div>
            ))}
          </div>
        }
      >
        <span>
          <Tag tagType={isAllReceived ? "green" : "gray"} rounded icon={false}>
            {receivedNonUsSubsidiaryBooks}/{totalNonUsSubsidiaryBooks} Received
          </Tag>
        </span>
      </ToolTip>
      <NonUsSubsidiaryBooksSlider
        {...nonUsSubsidiaryBookSlider}
        nonUsSubsidiaryBooks={nonUsSubsidiaryBooks}
        groupName={groupName}
        taskName={taskName}
      />
    </div>
  );
};
